import apiClient from '../client';

const STOCK_IN_BASE = `/digitization/v1/stock-in`;
const WAREHOUSE_BASE = `/traceability/v1/center/get_warehouse_list`;
const ORG_BASE = `/digitization/v1/organization/list`;
const PRODUCT_REPORT_BASE = `/digitization/v1/product/report`;

export const stockInApi = {
  createStockIn: data => apiClient.post(STOCK_IN_BASE, data),
  updateStockIn: (id, data) => apiClient.put(`${STOCK_IN_BASE}/${id}`, data),
  getStockIn: id => apiClient.get(`${STOCK_IN_BASE}/${id}`),
  deleteStockIn: id => apiClient.delete(`${STOCK_IN_BASE}/${id}`),
  getStockInReport: params => apiClient.post(`${STOCK_IN_BASE}/report`, params),
  getWarehouses: () => apiClient.get(WAREHOUSE_BASE),
  getOrganizations: () => apiClient.get(ORG_BASE),
  getProductReport: params => apiClient.post(PRODUCT_REPORT_BASE, params)
};

export default stockInApi;
